// extracted by mini-css-extract-plugin
module.exports = {"root":"DealCancelForm__root___K10EM"};